<template>
    <el-drawer :modal="false" 
        :visible.sync="showMessagingDrawer"
        class="messaging-drawer"
        size="25%"
        title="Filter "
    >
    <b-form ref="customerForm" role="form" @submit.prevent="submit()" >
            
            <!-- FILTER BY NAME -->
            <b-col cols="12" md="12">
                <b-form-group label="Filter by Name">
                    <el-select placeholder="Select">
                        <el-option>
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>

            <!-- FILTER BY ID -->
            <b-col cols="12" md="12">
                <b-form-group label="Filter by ID">
                    <el-select placeholder="Select">
                        <el-option>
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>
            
            <!-- FILTER BY CALL TYPE -->
            <b-col cols="12" md="12">
                <b-form-group label="Filter by Call Type">
                    <div class="d-flex justify-content-between">
                        <el-radio v-model="radio1" label="INBOUND" border value="hehe"><b-icon-telephone-outbound-fill></b-icon-telephone-outbound-fill>  OUTBOUND</el-radio>

                        <el-radio v-model="radio1" label="OUTBOUND" border value="huhu"><b-icon-telephone-inbound-fill></b-icon-telephone-inbound-fill>   INBOUND</el-radio>
                    </div>
                </b-form-group>
            </b-col>
            
            <!-- FILTER BY ASSIGN TO -->
            <b-col cols="12" md="12">
                <b-form-group label="Filter by Assign To">
                    <el-select placeholder="Select">
                        <el-option>
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>
            
            <!-- FILTER BY HUB -->
            <b-col cols="12" md="12">
                <b-form-group label="FIlter by Hub">
                    <el-select placeholder="Select">
                        <el-option>
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>

            <!-- FILTER BY SCHEDULED DATE -->
            <b-col cols="12" md="12">
                <b-form-group label="Filter by Scheduled Date">
                    <el-select placeholder="Select">
                        <el-option>
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>

            <!-- FILTER BY SCHEDULED TIME -->
            <b-col cols="12" md="12">
                <b-form-group label="Filter by Scheduled Time">
                    <el-select placeholder="Select">
                        <el-option>
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>
            
            <!-- <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                <b-button type="submit" class="w-100" variant="primary">Create</b-button>
            </b-col> -->
        </b-form>
    </el-drawer>
    
</template>
<script>
import { Drawer, Option, Select, Tabs, TabPane, Radio } from 'element-ui'
import Chats from '@/views/Messaging/Chats/MessagingChats'
import MessagingDocuments from '@/views/Messaging/Documents/MessagingDocuments'
import ActivityLogs from '@/views/Messaging/Logs/MessagingLogs'

export default {
    components:{
        Chats,
        MessagingDocuments,
        ActivityLogs,
        [Drawer.name]: Drawer,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        [Radio.name]: Radio,
    },
    props: {
        showCreatNewGroup: Boolean,
        showMainPage: Boolean,
        showChatRooms: Boolean,
    },
    data(){
        return {
            radio1:"",
            showMessagingDrawer: false,
        }
    },
    methods: {
        emitEvent(eventName) {
            chatEventBus.$emit(eventName);
        },
        viewMessagingDrawer() {
            this.showMessagingDrawer = !this.showMessagingDrawer
        }
    },
}
</script>